module.exports = {
      id: "d0e5df2dce743459d2cb23a3f81fe8e9kitchenEquipment-induction-hob.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#d0e5df2dce743459d2cb23a3f81fe8e9kitchenEquipment-induction-hob.svg",
      toString: function () {
        return this.url;
      }
    }